var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcoDown = function SvgIcoDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56908 9.03715C3.76435 9.23241 4.08093 9.23241 4.27619 9.03714L7.45817 5.85516C7.65343 5.6599 7.65343 5.34332 7.45817 5.14806C7.26291 4.95279 6.94632 4.95279 6.75106 5.14806L3.92264 7.97649L1.09421 5.14806C0.898946 4.9528 0.582363 4.9528 0.387101 5.14806C0.191839 5.34332 0.191839 5.65991 0.387102 5.85517L3.56908 9.03715ZM3.42263 0.352509L3.42264 8.68359L4.42264 8.68359L4.42263 0.352508L3.42263 0.352509Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-down.38e9e1b6.svg";
export { ForwardRef as ReactComponent };